import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select.component';
import { IconModule } from '../icon/icon.module';
import { OptionsModule } from '../options/options.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';



@NgModule({
  declarations: [SelectComponent],
  imports: [
    CommonModule,
    IconModule,
    OptionsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule
  ],
  exports: [SelectComponent]
})
export class SelectModule { }
